import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface BusinessSettingApiItem {
  type: string;
  value?: unknown;
}

export interface BusinessSettingsResponseDto {
  data: BusinessSettingApiItem[];
  success: boolean;
  status: number;
  message?: string;
}

export interface UpdateBusinessSettingDto {
  type: string;
  value: unknown;
}

export interface UpdateBusinessSettingsDto {
  settings: UpdateBusinessSettingDto[];
}

export interface BusinessSettingsActionResponseDto {
  success?: boolean;
  status?: number;
  message?: string;
  data?: unknown;
}

@Injectable({
  providedIn: 'root'
})
export class BusinessSettingsService {

  constructor(private http: HttpClient) { }

  private get apiUrl(): string {
    const base = localStorage.getItem('apiURL');

    if (!base) {
      throw new Error('apiURL not ready');
    }

    return `${base.replace(/\/+$/, '')}/api/v2`;
  }
  getClientName(): string {
    const base = localStorage.getItem('apiURL');

    if (!base) {
        return '';
    }

    try {
        const url = new URL(base);
        const parts = url.hostname.split('.');

        return parts.length >= 2
            ? parts[1].toLowerCase()
            : '';
    }
    catch {
        return '';
    }
}
getBusinessSettings(
  type: string = ''
): Observable<BusinessSettingsResponseDto> {

  return this.http.get<BusinessSettingsResponseDto>(
    `${this.apiUrl}/business-settings`,
    {
      params: type
        ? { type }
        : {}
    }
  );
}

  updateBusinessSetting(
    payload: UpdateBusinessSettingDto
  ): Observable<BusinessSettingsActionResponseDto> {
    return this.http.put<BusinessSettingsActionResponseDto>(
      `${this.apiUrl}/business-settings`,
      [payload]
    );
  }

  updateBusinessSettings(
    payload: UpdateBusinessSettingsDto
  ): Observable<BusinessSettingsActionResponseDto> {
    return this.http.put<BusinessSettingsActionResponseDto>(
      `${this.apiUrl}/business-settings`,
      payload.settings
    );
  }
}
